document
  .querySelector('.banner-call .banner__carousell')
  ?.addEventListener('click', () => {
    const googleBtn = document.querySelector('.qxCTlb');

    if (googleBtn) googleBtn.click();
  });

document.querySelectorAll('.openCalendar')?.forEach(btn => {
  btn.addEventListener('click', e => {
    e.preventDefault();

    const googleBtn = document.querySelector('.qxCTlb');
    if (googleBtn) {
      googleBtn.click();
    }
  });
});
